"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var Cookies = __importStar(require("js-cookie"));
var pick_1 = __importDefault(require("lodash/pick"));
var react_1 = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
var react_query_1 = require("react-query");
var react_router_dom_1 = require("react-router-dom");
var modal_1 = __importDefault(require("../../../plugins/modal"));
var crumb_nav_1 = __importDefault(require("../../account-v3/components/crumb_nav"));
var loading_modal_1 = __importDefault(require("../../account-v3/components/loading_modal"));
var magic_link_1 = require("../../magic-link");
var api_1 = require("../api");
var app_1 = require("../app");
var createSupportTicket_1 = require("../mutations/createSupportTicket");
var REASONS_TREE = [
    {
        value: 'PRODUCT_OR_ORDER_ISSUE',
        text: 'Product or order issue',
        choices: [
            { value: 'WRONG_OR_MISSING_ITEM', text: 'Wrong or missing item', action: 'cs_ticket' },
            { value: 'DEFECT', text: 'Defect or Damage', action: 'cs_ticket' },
            { value: 'DISSATISFIED', text: 'Product dissatisfaction', action: 'return' },
            { value: 'WRONG_ITEM_ORDERED', text: 'Ordered Wrong Item', action: 'return' },
            { value: 'COULDNT_EDIT', text: 'Unable to Update Order in Time', action: 'return' },
            { value: 'ALLERGIC_REACTION', text: 'Allergic Reaction', action: 'cs_ticket' },
        ],
    },
    {
        value: 'SHIPMENT_OR_SUBSCRIPTION_ISSUE',
        text: 'Shipment or subscription issue',
        choices: [
            { value: 'LATE', text: 'Order arrived too late', action: 'return' },
            { value: 'SUBSCRIPTION_NOT_NEEDED', text: 'No longer want a subscription', action: 'return' },
            { value: 'SUBSCRIPTION_TOO_FREQUENT', text: 'Subscription frequency too often', action: 'return' },
            { value: 'WANTED_TO_CANCEL', text: 'Meant to cancel before shipment', action: 'return' },
            { value: 'ACCIDENTAL_SUBSCRIPTION', text: "Didn't mean to subscribe", action: 'return' },
            { value: 'OTHER_SHIPMENT_ISSUE', text: "Other shipment issue", action: 'return' },
        ],
    },
    {
        value: 'OUTGROWN',
        text: 'Outgrown',
        choices: [
            { value: 'DIFFERENT_SIZE', text: 'Need a different size', action: 'return' },
            { value: 'POTTY_TRAINED', text: 'Potty trained', action: 'return' },
        ],
    },
    {
        value: 'PREFERENCE',
        text: 'Preference',
        choices: [
            { value: 'PRINT_OR_SCENT_SWAP', text: 'Print or scent swap', action: 'return' },
            { value: 'NOT_NEEDED', text: 'No longer want or need', action: 'return' },
            { value: 'FOUND_ALTERNATIVE', text: 'Found alternative', action: 'return' },
        ],
    },
    {
        value: 'PRICE',
        text: 'Price',
        choices: [
            { value: 'PRICING_ERROR', text: 'Pricing error', action: 'cs_ticket' },
            { value: 'PRICE_TOO_HIGH', text: 'Price too high', action: 'return' },
            { value: 'CHEAPER_ALTERNATIVE_AVAILABLE', text: 'Found cheaper alternative', action: 'return' },
        ],
    },
];
exports.default = (function (_a) {
    var _b, _c, _d;
    var basePath = _a.basePath;
    var context = (0, react_1.useContext)(app_1.NewReturnContext);
    var history = (0, react_router_dom_1.useHistory)();
    var queryClient = (0, react_query_1.useQueryClient)();
    var _e = __read((0, react_1.useState)(), 2), supportTicketId = _e[0], setSupportTicketId = _e[1];
    var isCS = !!Cookies.get(magic_link_1.SUBLESS_JWT_COOKIE_NAME);
    var _f = (0, react_query_1.useMutation)(app_1.QueryKey.MUTATION_CREATE_SUPPORT_TICKET, function (variables) { return (0, api_1.getSublessAPIClient)().request(createSupportTicket_1.CREATE_SUPPORT_TICKET, variables); }, {
        onError: function (err, v) { return console.error(err, v); },
        onSuccess: function () { return queryClient.invalidateQueries([[app_1.QueryKey.ELIGIBLE_RETURN_ORDERS, { csNumDays: 0 }], app_1.QueryKey.GET_RETURNS]); },
    }), isCreatingSupportTicket = _f.isLoading, createSupportTicketMutation = _f.mutateAsync, createSupportTicketError = _f.error;
    if (!context)
        return null;
    var selectedItems = context.selectedItems, setCreateReturnInput = context.setCreateReturnInput;
    if (selectedItems.length === 0) {
        history.push("".concat(basePath, "/selectItems"));
        return null;
    }
    var _g = (0, react_hook_form_1.useForm)({
        mode: 'onChange',
    }), handleSubmit = _g.handleSubmit, register = _g.register, formState = _g.formState, watch = _g.watch;
    var formValues = watch();
    var csTicketNeeded = !isCS &&
        !!formValues.parentReason &&
        !!formValues.reason &&
        ((_c = (_b = REASONS_TREE.find(function (t) { return t.value === formValues.parentReason; })) === null || _b === void 0 ? void 0 : _b.choices.find(function (c) { return c.value === formValues.reason; })) === null || _c === void 0 ? void 0 : _c.action) === 'cs_ticket';
    var submitForm = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var items, input, reason, result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    items = selectedItems.map(function (i) {
                        // const reason = values.returnItem.find((r) => r.lineItemId === i.lineItemId)?.reason || ''
                        return (0, pick_1.default)(i, ['orderId', 'lineItemId', 'quantity']);
                    });
                    console.debug({ reason: values.reason, items: items });
                    input = {
                        reason: values.reason,
                        customerNote: values.customerNote,
                        items: items,
                    };
                    setCreateReturnInput(input);
                    if (!csTicketNeeded) return [3 /*break*/, 2];
                    reason = (_a = REASONS_TREE.find(function (t) { return t.value === formValues.parentReason; })) === null || _a === void 0 ? void 0 : _a.choices.find(function (c) { return c.value === formValues.reason; });
                    if (reason)
                        input.reason = reason === null || reason === void 0 ? void 0 : reason.text;
                    return [4 /*yield*/, createSupportTicketMutation({ input: input })];
                case 1:
                    result = _b.sent();
                    setSupportTicketId(result.account_createReturnSupportTicket.id);
                    return [3 /*break*/, 3];
                case 2:
                    history.push("".concat(basePath, "/returnMethod"));
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var createSupportTicket = function () { return __awaiter(void 0, void 0, void 0, function () {
        var items, input, reason, result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    items = selectedItems.map(function (i) {
                        // const reason = values.returnItem.find((r) => r.lineItemId === i.lineItemId)?.reason || ''
                        return (0, pick_1.default)(i, ['orderId', 'lineItemId', 'quantity']);
                    });
                    input = {
                        reason: formValues.reason,
                        customerNote: formValues.customerNote,
                        items: items,
                    };
                    reason = (_a = REASONS_TREE.find(function (t) { return t.value === formValues.parentReason; })) === null || _a === void 0 ? void 0 : _a.choices.find(function (c) { return c.value === formValues.reason; });
                    if (reason)
                        input.reason = reason === null || reason === void 0 ? void 0 : reason.text;
                    return [4 /*yield*/, createSupportTicketMutation({ input: input })];
                case 1:
                    result = _b.sent();
                    setSupportTicketId(result.account_createReturnSupportTicket.id);
                    return [2 /*return*/];
            }
        });
    }); };
    var reasonOptions;
    if (!!formValues.parentReason) {
        reasonOptions = (_d = REASONS_TREE.find(function (t) { return t.value === formValues.parentReason; })) === null || _d === void 0 ? void 0 : _d.choices.map(function (c) { return ({ value: c.value, text: c.text }); });
    }
    var parentReasonOptions = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("option", { value: '', key: 'empty' }, "Select Category"),
        REASONS_TREE.map(function (r) { return (react_1.default.createElement("option", { value: r.value, key: r.value }, r.text)); })));
    return (react_1.default.createElement("div", { className: 'padding-bottom-3 return-container' },
        react_1.default.createElement(crumb_nav_1.default, { current: 'Returns', backLink: "".concat(basePath, "/selectItems") }),
        react_1.default.createElement(loading_modal_1.default, { isLoading: isCreatingSupportTicket, error: createSupportTicketError, loadingText: 'Creating Customer Support Ticket' }),
        react_1.default.createElement(modal_1.default, { isOpen: !!supportTicketId, handleClose: function () {
                history.replace("/returns/");
            } },
            react_1.default.createElement("div", { className: 'padding-6' },
                react_1.default.createElement("div", { className: 'padding-top-10 padding-bottom-5 account-header' }, "We have created a support request for you"),
                react_1.default.createElement("div", { className: 'padding-left-4 padding-right-4' },
                    react_1.default.createElement("p", null,
                        "Your Support Request: #",
                        supportTicketId),
                    react_1.default.createElement("div", { className: 'font-size-small font-lighter' }, "Our Customer Enjoyment team will be in touch with you soon."),
                    react_1.default.createElement(react_router_dom_1.Link, { className: 'button btn-form display-block text-center margin-top-4', to: "/returns/", replace: true }, "Done")))),
        react_1.default.createElement("div", { className: 'padding-top-10 padding-bottom-5 account-header' }, window.returnsApp.copy.reasonsStepHeader),
        react_1.default.createElement("div", { className: 'padding-left-4 padding-right-4' },
            react_1.default.createElement("div", { className: 'font-lighter font-size-small', dangerouslySetInnerHTML: { __html: window.returnsApp.copy.reasonsStepCopy } }),
            react_1.default.createElement("form", { onSubmit: handleSubmit(submitForm) },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("select", { name: 'parentReason', placeholder: 'Reason for Return', ref: register({
                            required: 'Required',
                        }) }, parentReasonOptions),
                    react_1.default.createElement("select", { name: 'reason', ref: register({ required: 'Required' }), className: (0, classnames_1.default)({ hide: !formValues.parentReason }) },
                        react_1.default.createElement("option", { value: '', key: 'empty' }, "Select a reason"),
                        (reasonOptions || []).map(function (o) { return (react_1.default.createElement("option", { key: o.value, value: o.value }, o.text)); }))),
                !!formValues.reason && (react_1.default.createElement("div", null,
                    react_1.default.createElement("p", { className: 'font-lighter font-size-small' }, "Anything you would like to tell us (Optional)"),
                    react_1.default.createElement("textarea", { name: 'customerNote', placeholder: 'Comments', ref: register({}), cols: 2 }))),
                csTicketNeeded && (react_1.default.createElement("div", { className: 'margin-top-4' },
                    react_1.default.createElement("p", { className: 'font-lighter font-size-small' }, "We take your request seriously. To help you to the best of our abilities, please click the button below to create a customer support ticket."))),
                react_1.default.createElement("div", { className: 'margin-top-6 account-return-panel' }, selectedItems.map(function (item, index) {
                    var _a, _b;
                    return (react_1.default.createElement("div", { key: item.lineItemId, className: 'media-object  margin-bottom-4' },
                        react_1.default.createElement("div", { className: 'media-object-section align-self-top' },
                            react_1.default.createElement("div", { className: 'return-item-img-container margin-left-4 margin-right-3' }, item.imageSrc && react_1.default.createElement("img", { src: item.variant.imgSrc || ((_a = item.variant.product) === null || _a === void 0 ? void 0 : _a.imgSrc) }))),
                        react_1.default.createElement("div", { className: 'media-object-section main-section align-self-top font-size-small font-lighter position-relative' },
                            react_1.default.createElement("div", { className: 'float-right margin-left-1' },
                                "Qty: ",
                                item.quantity),
                            react_1.default.createElement("div", { className: 'margin-bottom-2' },
                                ((_b = item.variant.product) === null || _b === void 0 ? void 0 : _b.title) || item.variant.title,
                                item.variant.option1 && (react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement("br", null),
                                    react_1.default.createElement("span", { className: 'text-brownish-grey' },
                                        item.variant.option1,
                                        " ",
                                        item.variant.option2 ? " / ".concat(item.variant.option2) : '')))))));
                })),
                react_1.default.createElement("div", { className: 'checkout-cta-container' },
                    !csTicketNeeded && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_router_dom_1.Link, { to: "".concat(basePath, "/selectItems"), className: 'text-center display-block margin-bottom-2 font-lighter font-size-small link-wisteria' }, "Change Item Selection"),
                        react_1.default.createElement("button", { className: (0, classnames_1.default)({ 'button btn-form': true }), type: 'submit', disabled: !formState.isValid }, "Continue"))),
                    csTicketNeeded && (react_1.default.createElement("button", { className: (0, classnames_1.default)({ 'button btn-form': true }), disabled: !formState.isValid || isCreatingSupportTicket, onClick: function () { return createSupportTicket(); } },
                        isCreatingSupportTicket && react_1.default.createElement("img", { style: { width: '1em', height: '1em', marginRight: '1em' }, src: window.returnsApp.iconUrls.spinnerWhite }),
                        "Create Support Ticket")))))));
});
